import { render, staticRenderFns } from "./RetencionDelete.vue?vue&type=template&id=4721a429"
import script from "./RetencionDelete.vue?vue&type=script&lang=js"
export * from "./RetencionDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports